import { render, staticRenderFns } from "./tempPage.vue?vue&type=template&id=1d9b7214&scoped=true&"
import script from "./tempPage.vue?vue&type=script&lang=js&"
export * from "./tempPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9b7214",
  null
  
)

export default component.exports